import React from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'

const GeneralSection = () => {
  const { t } = useTranslation('minicruds')
  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" wrapOn="sm">
        <FormItem label={t('name')} field="name" />
      </Col>
    </Grid>
  )
}

export default GeneralSection
